// import DS from "@/data-services/";
import { calculateServerRouting } from "@/api/heremap";
import { convertMetersToMiles } from '@/filters'

// detailRouteV8 数据带洗漱
import { routeV8Info } from './add-route.js'
// import { loadAssignRoute } from '../../views/dispatchs/dispatch/api/new-index.js'


export function hereApi(data) {
    return new Promise(( resolve, reject ) => {
        // const baseCache = DS.getFunctionCache(
        //     "LoadDetail-calculaterouteV8",
        //     calculateServerRouting
        // )
        const resultData = data.dispatchStopPointList?.map(item => {
            return {
                latitude: item.lat,
                longitude: item.lon,
                pointType: 'address', // 
                dwellTime: 0, // 停留时间，单位秒
                addressName: '',
                id: '' 
            }
        }) || []
        calculateServerRouting(routeV8Info({loadInfo: data}, resultData)).then(( res ) => {
            resolve({
                distance: convertMetersToMiles(res[0].summary.distance,2),
                summary: res[0].summary.distance,
                hereResultData: res[0]
            })
        }).catch(( error ) => {
            console.log(error,'30');
            if(error) {
               reject('Unable to create a route for the selected locations.') 
            }
        })
    })
}

// export function commonRouteApi(loadParams) {
//     const baseCache = DS.getFunctionCache(
//         "LoadDetail-calculaterouteV8",
//         calculaterouteV8
//     )
//     return new Promise((resolve, reject) => {
//         baseCache.getData(routeV8Info({loadInfo: data})).then(( res ) => {
//             paramsFunc(convertMetersToMiles(res[0].summary.distance,2), loadParams, res[0])
//             loadAssignRoute(res[0]).then(( res ) => {
//                 resolve(res)
//                 reject()
//             }).catch(( error ) => {
//                 reject(error)
//             })
//        })
//     })
// }